import "./AccountFlyoutGreeting.scss";

import * as React from "react";
import { Person } from "../../../../../datatypes/businessaccounts/BusinessAccount";
import { FormattedMessage } from "react-intl";

type Props = {
    person: Person;
    setIsMenuVisible: (isMenuVisible: boolean) => void;
};
const getGreeting = (name: string) => {
    const displayName: string = name + "!";
    return (
        <React.Fragment>
            <FormattedMessage id={"CA_BRANDBAR_MOBILE_GREETING"} />
            <span>{displayName}</span>
        </React.Fragment>
    );
};

export function AccountFlyoutGreeting(props: Props) {
    const closeDropdown = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        props.setIsMenuVisible(false);
        window.document.body.classList.remove("disable-scrolling");
    };

    return (
        <div className="greet-section">
            {getGreeting(props.person.name)}
            <div className="close-button" onClick={(event) => closeDropdown(event)}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="16px"
                    height="16px"
                    viewBox="0 0 16 16"
                    version="1.1">
                    <defs>
                        <path
                            d="M13.70725,12.29325 C14.09825,12.68425 14.09825,13.31625 13.70725,13.70725 C13.51225,13.90225 13.25625,14.00025 13.00025,14.00025 C12.74425,14.00025 12.48825,13.90225 12.29325,13.70725 L8.00025,9.41425 L3.70725,13.70725 C3.51225,13.90225 3.25625,14.00025 3.00025,14.00025 C2.74425,14.00025 2.48825,13.90225 2.29325,13.70725 C1.90225,13.31625 1.90225,12.68425 2.29325,12.29325 L6.58625,8.00025 L2.29325,3.70725 C1.90225,3.31625 1.90225,2.68425 2.29325,2.29325 C2.68425,1.90225 3.31625,1.90225 3.70725,2.29325 L8.00025,6.58625 L12.29325,2.29325 C12.68425,1.90225 13.31625,1.90225 13.70725,2.29325 C14.09825,2.68425 14.09825,3.31625 13.70725,3.70725 L9.41425,8.00025 L13.70725,12.29325 Z"
                            id="path-1"></path>
                    </defs>
                    <g id="Icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Icon-/-small-/-close-small">
                            <rect id="fill" x="0" y="0" width="16" height="16"></rect>
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <use id="color" fill="#ffffff" xlinkHref="#path-1"></use>
                        </g>
                    </g>
                </svg>
            </div>
        </div>
    );
}
